(function($, root, undefined) {

    $(function() {

        'use strict'; // DOM ready, take it away

        // Responsive Menu
		var responsiveMenu = $('.responsive-nav').scotchPanel({
            useCSS: false,
			containerSelector: 'body',
			direction: 'left',
			duration: 50,
			transition: 'ease',
			clickSelector: '.mobile_toggle',
			distanceX: '100%',
			enableEscapeKey: false
		});

		$('.mobile_toggle').click(function(event) {
			$(this).toggleClass('active');
			$('.blackout').fadeIn('fast');
			$('.blackout').addClass('active');
			$('.responsive-nav').addClass('responsive-nav--is-active');
			responsiveMenu.open();
			$("html, body").animate({
				scrollTop: 0
			}, 600);
			return false;
		});

		$('.blackout').click(function(event) {
			responsiveMenu.close();
			$('.blackout').fadeOut('fast');
			$('.blackout').removeClass('active');
			$('.mobile_toggle').removeClass('active');
			$('.responsive-nav').removeClass('responsive-nav--is-active');
			return false;
		});

		$('.responsive-nav__close').click(function(event) {
			$('.blackout').trigger('click');
		});

		$(window).resize(function() {
			if ($(window).width() >= 769 && $('.scotch-panel-canvas').hasClass('scotch-is-showing')) {
				responsiveMenu.close();
			}
		});

        // Footer fanciness
        // $('.footer__social div').each(function() {
        //     var hoverClass = 'footer--' + $(this).attr('class');
        //     $(this).hover(function() {
        //         $('.footer').addClass(hoverClass);
        //     }, function() {
        //         $('.footer').removeClass(hoverClass);
        //     });
        // });
        // end footer fanciness

		$('.mega__list li').on('mouseenter', function(e) {
			var id = $(this).attr('data-id');
			var classToShow = '.js-menu-item-' + id;
			$('.mega__features').hide();
			$('.mega__image').hide();
			$(classToShow).show();
		});

		$('[data-menu]').on('mouseenter', function(e) {
			var menu = $(this).attr('data-menu');
			var classToShow = '.js-megamenu-' + menu;
			var headerHeight = $('.header').outerHeight(true);
			$(classToShow).css({
				'top': headerHeight,
				'width': '100%',
				'position': 'fixed',
				'z-index': '1000',
				'display': 'block'
			});
		});

		$('[data-menu]').on('mouseleave', function(e) {
			$('.mega').hide();
		});

		$('.mega').on('mouseenter', function(e) {
			$(this).show();
		});

		$('.mega').on('mouseleave', function(e) {
			$(this).hide();
		});


        //remove whitespace
        $.fn.removeSpace = function() {
            $(this).contents().filter(function() {
                return this.nodeType === 3;
            }).remove();
        };
        //use it
        $('.pagination').removeSpace();

        // Match Height
        // $('.testimonials__col').matchHeight();
		$('.testimonials__col').matchHeight({ byRow: true, property: 'min-height'});
        $('.blog__title').matchHeight();
        $('.search__input, .search__button').matchHeight();
        $('.whatweoffer__image').matchHeight();
        $('.child-services__col, .box').matchHeight();

        // End Match Height

        // Homepage Contact Form
        $('.js-send-email').on('click', function(e) {
            e.preventDefault();
            $('#field_contact_type').val('Email');
            $('.js-calltoaction-form').submit();
        });
        $('.js-callback').on('click', function(e) {
            e.preventDefault();
            $('#field_contact_type').val('Call Back');
            $('.js-calltoaction-form').submit();
        });
        // End Homepage Contact Form

        // Search
        $('.js-search-toggle').on('click', function(e) {
            e.preventDefault();
            $('.blackout').fadeToggle('fast').toggleClass('active');
            $('.sitesearch').fadeToggle('fast').toggleClass('sitesearch--active');
        });
        // End Search

        // Breadcrumb first item
        $('a.home').html('<i class="fa fa-home"></i>');
        // end breadcrumb first item

        // remove empty P tags 
        $('p').each(function() {
            var $this = $(this);
            if ($this.html().replace(/\s|&nbsp;/g, '').length === 0)
                $this.remove();
        });
        // end remove empty P tags

        // add target="_blank" to links
        $('.entry-content a').each(function() {
        	$(this).attr('target','_blank');
        });
        // end add target="_blank" to links

        // slick
        $('.ourtestimonials__slider').slick({
            slidesToShow: 3,
            centerMode: true,
            arrows: true,
            infinite: true,
            draggable: false,
            autoplay: true,
            responsive: [{
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    infinite: true,
                    draggable: true
                }
            }]
        });

        function calculateSpecialismsSlider() {
	        if ($(window).width() > 768) {
		        $('.specialisms__slider').slick({
		            slidesPerRow: 3,
		            rows: 2,
		            arrows: true,
		            infinite: true,
		            draggable: true,
		        });
	    	} else {
		        $('.specialisms__slider').slick({
		            slidesToShow: 1,
		            arrows: true,
		            infinite: true,
		            draggable: true,
		        });
	    	}
    	}

        $(window).resize(function() {
			calculateSpecialismsSlider();
        });
        
		calculateSpecialismsSlider();

        console.log('slider loaded');

        $('.hero').slick({
			infinite: true,
			speed: 500,
			slidesToShow: 1,
			draggable: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 2500,
			fade: true,
			cssEase: 'linear'
        });

		$('.testimonials__slider').slick({
			infinite: true,
			speed: 1000,
			slidesToShow: 1,
			draggable: true,
			arrows: true,
			dots: false,
			autoplay: true,
			autoplaySpeed: 3500,
			// adaptiveHeight: true,
			appendArrows: $('#testimonialslidercontrols'),
			prevArrow:"<i class='fa fa-4x fa-angle-left fa-inverse slider-prev'></i>",
			nextArrow:"<i class='fa fa-4x fa-angle-right fa-inverse slider-next'></i>"
		});
        // end slick

        // enable select2 by uncommenting this
        // $('select').select2();

        // Header height
        function setHeaderHeight() {
            var headerHeight = $('#header').outerHeight(true);
            $('.spacer').css('padding-bottom', headerHeight);
        }

        setHeaderHeight();

        $(window).resize(function() {
            setHeaderHeight();
        });

        // Fixed header
        $(document).scroll(function() {
            if ($(this).scrollTop() > 300) {
                $('#header').addClass('header--fixed');
            } else {
                $('#header').removeClass('header--fixed');
            }
        });
        // end Fixed header

        // hack the form on the contact page
        $('.page-template-template-contact').find('form').removeClass('form--white').addClass('form--contact');

        // isotope
        if ($(window).width() > 768) {
            var $mode;

            if ($('.filterable').hasClass('filterable--masonry')) {
                $mode = 'masonry';
            } else {
                $mode = 'fitRows';
            }

            var $grid = $('.filterable').isotope({
                itemSelector: '.filterable__item',
                layoutMode: $mode
            });

            $('.filterbar__filterbox a').click(function(e) {
                e.preventDefault();
                var buttonVal = $(this).attr('data-filter');

                console.log(buttonVal);

                if (buttonVal == "all") {
                    $grid.isotope({
                        filter: '*'
                    });
                } else {
                    $grid.isotope({
                        filter: '.' + buttonVal
                    });
                }

                if (!$grid.data('isotope').filteredItems.length) {
                    $('.filterbar__noresults').show();
                } else {
                    $('.filterbar__noresults').hide();
                }

            });
        }

        $('.filterbar__filterbox').on('click', function() {
            $('.filterbar__filterbox').removeClass('filterbar__filterbox--active');
            $(this).toggleClass('filterbar__filterbox--active');
        });
        // end isotope 

        // friendly mailto
        $('a[href^="mailto:"]').html(function(_, oldhtml) {
            return oldhtml.replace(/([@.])/g, "<wbr>$1");
        });
        // end friendly mailto


        /*Function for speeding calculator - start*/
        function calculate_fine_and_points(){
            var reading = $("#reading").val();

            if($.isNumeric(reading)&&reading>=0)
                {
                    //calculate
                    $.ajax({
                            url: admin_ajax.ajaxurl,
                            data: {
                                'action':'calculate_speeding_points',
                                'data' : $("#speed_calc").serialize()
                            },
                            type: 'POST'
                            }).done(function(result) { 
                                var arr_data  = result.split('@@###@@');                    
                                var fine = $.trim(arr_data[0]);
                                var points = $.trim(arr_data[1]);
                                var legalWarn = $.trim(arr_data[2]);
                                if(points == 'A DISQUALIFICATION'){
                                    $('#expectedFine').text(fine);
                                    $('#receivedText').html('The Result: <span id="receivedPoint">The court will be advised to disqualify you, we can help you avoid this, call us on 0800 1933 999.</span><p>'+ legalWarn +'</p>');
                                }
                                else if(points == '4-6 points or a disqualification') {
                                    $('#expectedFine').text(fine);
                                    $('#receivedText').html('The Result: <span id="receivedPoint">The court will be advised to impose 4 – 6 points or disqualify you, we can help you avoid a disqualification, call 0800 1933 999.</span><p>'+ legalWarn +'</p>');
                                }
                                else
                                {
                                    $('#expectedFine').text(fine);
                                    $('#receivedText').html('You will receive <span id="receivedPoint"></span> on your license.<p>'+ legalWarn +'</p>');
                                    $('#receivedPoint').text(points);
                                }
                                $('#calculator_response').show();
                            }); 
                    
                }
            else
                {
                    alert('Please enter correct speed value.'); 
                    $("#reading").focus();          
                }
        }
        /*Function for speeding calculator - end*/


        // $('#calculate_button').click(function(event) {
        //     calculate_ban();
        // });

        /*for speeding calculator - start*/
        $('#speed_calculate_button').click(function(event) {
            calculate_fine_and_points();
        });
        /*for speeding calculator - end*/
        
        $('#calculator_response').hide();
        $('#callusonban').hide();


        $('.speeding-calculator__intro').matchHeight();
        $('.speeding-calculator__content').matchHeight();






        // DRINKING CALCULATOR


        $('.form-drinking-calculator').submit(function() {



            $.ajax({
                url: admin_ajax.ajaxurl,
                type: 'POST',
                dataType: 'json',
                data: {
                    'action': 'calculate_drinking_units',
                    'data' : $('.form-drinking-calculator').serialize()
                },
                success:function(data) {


                        

                    $('.drinking-calculator__results').empty().removeClass('is-active');

                    if (data.length > 0) {
                        //add result
                        $('.drinking-calculator__results').addClass('is-active').append(data);
                    } else {
                        $('.drinking-calculator__results').addClass('is-active').append('<h3 style="margin:0;">No results</h3>');
                    }


                }
            });


            return false;





        });

    });

})(jQuery, this);